import CustomModuleCards from '../../components/CustomModuleCard/CustomModuleCards';
import { ViewModule } from '../../types/api/payload/module';

export default function CompanyMarketPlace() {
  return <CustomModuleCards view={ViewModule.companyMarketplace} />;
}
